// extracted by mini-css-extract-plugin
export var collapsablesItem = "Collapsables-module--collapsablesItem--Gz+ei";
export var collapsablesItem__title = "Collapsables-module--collapsablesItem__title--mecpo";
export var icon_plus = "Collapsables-module--icon_plus--LgPoG";
export var collapsablesItem__content = "Collapsables-module--collapsablesItem__content--Arg1U";
export var collapsablesItem_open = "Collapsables-module--collapsablesItem_open--OIPxR";